import React from 'react';
import { CategoryTypeString } from '@diritto/common/content/constants';
import { ContentPublicRelayDto } from '@diritto/common/relay/dtos/content-relay.dtos';
import { ProfileLitePublicRelayDto } from '@diritto/common/relay/dtos/profile-lite-relay.dtos';
import { Color } from '@diritto/common/style/color';
import { DotDivider } from 'ui-components/common/DotDivider';
import { Link } from 'ui-components/common/Link';
import { ContentCover } from 'ui-components/contents/ContentCover';
import { IconCount, IconCountType } from 'ui-components/contents/IconCount';
import { ProfileName } from 'app-components/contents/ProfileName';

type SectionRankItemProps = {
  content: ContentPublicRelayDto;
  profile: ProfileLitePublicRelayDto;
  rank: number;
  showCategory?: boolean;
  showViewCount?: boolean;
  onClick: () => void;
};

export const SectionRankItem = ({
  content,
  profile,
  rank,
  showCategory = false,
  showViewCount = false,
  onClick,
}: SectionRankItemProps) => (
  <div
    aria-hidden="true"
    onClick={onClick}
    role="button"
    tabIndex={0}
    className="flex items-center flex-row gap-3 md:w-[338px] w-[300px]">
    <Link href={`/contents/${content.id}`}>
      <ContentCover content={content} size={100} />
    </Link>
    <p className="flex-shrink-0 text-center w-[33px] text-black font-bold text-sm">{rank}</p>
    <div className="flex flex-col justify-end flex-shrink gap-1">
      <div className="flex flex-row gap-1">
        <Link href={`/contents/${content.id}`}>
          <p className={`text-black text-desc font-bold text-xs line-clamp-2`}>{content.title}</p>
        </Link>
      </div>
      <div className="flex flex-row gap-1 font-medium text-xxxs text-gray-700">
        <ProfileName profile={profile} />
        {showCategory ? (
          <>
            <DotDivider />
            <div>{CategoryTypeString[content.categoryType]}</div>
          </>
        ) : null}
        <DotDivider />
        <div>{`${content.counts.episodeCount}화`}</div>
      </div>
      {showViewCount && (
        <div className="flex flex-row gap-1 font-medium text-xxxs text-gray-700">
          <IconCount type={IconCountType.View} count={content.counts.viewCount || 0} color={Color.Gray400} />
        </div>
      )}
    </div>
  </div>
);
